import { io, Socket } from "socket.io-client";

// Socket.IO connects to the API's origin, not the "/api"-suffixed REST base
// used everywhere else — strip that suffix off VITE_API_BASE_URL.
const SOCKET_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/api\/?$/, '');

let socket: Socket | null = null;
let registeredUserId: string | null = null;

export const connectSocket = (userId: string) => {
  if (!userId) return;
  if (socket && registeredUserId === userId) return;
  if (socket) {
    socket.disconnect();
    socket = null;
  }

  registeredUserId = userId;
  socket = io(SOCKET_URL, { transports: ["websocket"] });

  socket.on("connect", () => {
    socket?.emit("register", userId);
  });
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  registeredUserId = null;
};
